export const SERVER_HOST = 'https://dev.demo.lfs.rest/api'
